let ctx = null;

const getCtx = () => {
  if (!ctx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    ctx = new Ctx();
  }
  return ctx;
};

// Must be called from a user gesture at least once so beeps/auto-play are allowed.
export const unlockAudio = async () => {
  try {
    const c = getCtx();
    if (!c) return false;
    if (c.state === 'suspended') await c.resume();
    return c.state === 'running';
  } catch {
    return false;
  }
};

const tone = (freq, startOffset, duration, gain = 0.12) => {
  const c = getCtx();
  if (!c || c.state !== 'running') return;
  const osc = c.createOscillator();
  const vol = c.createGain();
  const t0 = c.currentTime + startOffset;
  osc.type = 'sine';
  osc.frequency.value = freq;
  vol.gain.setValueAtTime(0, t0);
  vol.gain.linearRampToValueAtTime(gain, t0 + 0.01);
  vol.gain.linearRampToValueAtTime(0, t0 + duration);
  osc.connect(vol).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.02);
};

export const playPressBeep = () => {
  try { tone(880, 0, 0.12); } catch { /* ignore */ }
};

export const playReleaseBeep = () => {
  try { tone(660, 0, 0.07); tone(520, 0.08, 0.09); } catch { /* ignore */ }
};

export const playIncomingChirp = () =>
  new Promise((resolve) => {
    try { tone(1200, 0, 0.07); tone(1600, 0.09, 0.07); } catch { /* ignore */ }
    setTimeout(resolve, 220);
  });

// Soft two-note chime for text/file alerts.
export const playChime = () => {
  try { tone(784, 0, 0.14, 0.09); tone(1046, 0.12, 0.2, 0.09); } catch { /* ignore */ }
};
